import {
  publishRulesHistoryFieldsDate,
  publishRulesHistoryFieldsDeadline,
} from '../constants/publishRulesHistoryFields';
import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';

export const getPublishRulesHistoryFieldsByCategory = (category: PublishRulesCategoriesEnum) => {
  if (category.startsWith('PLANNED')) {
    return publishRulesHistoryFieldsDate;
  }

  if (
    category.startsWith('UNPLANNED') ||
    category.startsWith('PM') ||
    category === PublishRulesCategoriesEnum.DECISION_PASSPORT
  ) {
    return publishRulesHistoryFieldsDeadline;
  }

  return publishRulesHistoryFieldsDate;
};
